import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { SupplierConfigurationPropertiesResponse, TaxCountryConfig, TaxIDType, WithHoldingTaxInfoResponse, SupplierConfigurationPropertiesPayload} from "../models/tax.model";
import { AppSettings } from "../../app.settings";
import { FieldConfig } from "../models/supplier.model";

@Injectable()
export class TaxService extends BaseService {

    constructor(private http: HttpClient, private config: AppSettings) {
        super();
    }

    /** Sends GET request to get tax ID types */
    getTaxIdTypes(): Observable<TaxIDType[]> {
        const url = `${this.config.BaseUrl}Profile/Tax/IDTypes`;
        return this.http.get<TaxIDType[]>(url, { headers: this.setHeaders() });
    }

    getTaxCountries(): Observable<TaxCountryConfig[]> {
        const url = `${this.config.BaseUrl}Profile/Tax/TaxCountries`;
        return this.http.get<TaxCountryConfig[]>(url, { headers: this.setHeaders() });
    }

    getIsWorkingWithUSEntityVerification(supplierCode: string): Observable<boolean> {
        const url = `${this.config.BaseUrl}Profile/Tax/${supplierCode}/isWorkingWithUSEntity`;
        return this.http.get<boolean>(url, { headers: this.setHeaders() });
    }

    getOnboardingTaxdocument(supplierCode: string, country: string): Observable<FieldConfig[]> {
        const url = `${this.config.BaseUrl}Profile/Onboarding/GetOnboardingTaxDocument/${supplierCode}/${country}`;
        return this.http.get<FieldConfig[]>(url, { headers: this.setHeaders() });
    }

    getIsWorkingWithTHEntityVerification(supplierCode: string): Observable<boolean> {
      const url = `${this.config.BaseUrl}Profile/Tax/${supplierCode}/isWorkingWithTHEntity`;
      return this.http.get<boolean>(url, { headers: this.setHeaders() });
    }

    getIsWorkingWithEntityVerification(supplierCode: string, selectedTaxCountry: string, skipUSEntityList: string): Observable<WithHoldingTaxInfoResponse> {
      const url = `${this.config.BaseUrl}Profile/Tax/${supplierCode}/isWorkingWithEntity?selectedTaxCountry=${selectedTaxCountry}&skipUSEntityList=${skipUSEntityList}`;
      return this.http.get<WithHoldingTaxInfoResponse>(url, { headers: this.setHeaders() });
    }

    getAdditionalSupplierConfig(configProperties : SupplierConfigurationPropertiesPayload): Observable<SupplierConfigurationPropertiesResponse> {
        const url = `${this.config.BaseUrl}Profile/Tax/supplierConfigurationProperties`;
        return this.http.post<SupplierConfigurationPropertiesResponse>(url, configProperties, { headers: this.setHeaders() });
    }
}
